import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Drawer from "components/ui/drawer/Drawer";
import { BidResponseForm, BidResponseFormOutput } from "./BidResponseForm";

type Props = {
  type: "create" | "edit";
  defaultValues?: Partial<BidResponseFormOutput>;
  onClose: () => void;
  isOpen: boolean;
  onComplete: () => void;
};

export function BidResponseDrawer({ type, defaultValues, onComplete, onClose, isOpen }: Props) {
  return (
    <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()} width={486} padding={32}>
      <FormContent>
        <Flex justifyContent="space-between" alignItems="center">
          <Text h2>{type === "create" ? "Create new bid response" : "Edit bid question"}</Text>
          <Button icon="xClose" buttonType="primary" buttonStyle="inverse" onClick={onClose} />
        </Flex>
        <BidResponseForm
          type={type}
          defaultValues={{ ...defaultValues }}
          onComplete={onComplete}
          onCancel={onClose}
        />
      </FormContent>
    </Drawer>
  );
}

const FormContent = styled(Flex)({
  flexDirection: "column",
  gap: 24,
  minHeight: "100%",
});
